import { render, staticRenderFns } from "./applyDetailBox.vue?vue&type=template&id=b9f61e9e"
import script from "./applyDetailBox.vue?vue&type=script&lang=js"
export * from "./applyDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports